import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ProductGridRow from './ProductGridRow.jsx';
import translations from '../translations';

import { getCurrentProductList, getNumberOfProductsPerRowInGrid } from '../helpers';

function ProductGrid(props) {
  const { productsList, numberOfProductsPerRow } = props;
  const productGrid = [];

  for (let index = 0; index < productsList.length; index += numberOfProductsPerRow) {
    const rowProductsList = productsList.slice(index, index + numberOfProductsPerRow);
    const key = `ids: ${rowProductsList.map((product) => product.id)} ` +
      `length: ${rowProductsList.length}`;

    productGrid.push(
      <ProductGridRow
        key={key}
        rowProductsList={rowProductsList}
        translations={translations}
      />
    );
  }

  return productGrid;
}

ProductGrid.propTypes = {
  productsList: PropTypes.arrayOf(PropTypes.object).isRequired,
  numberOfProductsPerRow: PropTypes.number.isRequired
};

function mapStateToProps(state) {
  return {
    productsList: getCurrentProductList(),
    numberOfProductsPerRow: getNumberOfProductsPerRowInGrid(state.general.viewportWidth)
  };
}

export default connect(mapStateToProps)(ProductGrid);
